<div @fadeInUp class="create-deal-container">
<!--	<cds-text-label [invalid]="dealNameInvalid" [invalidText]="dealNameInvalidText">-->
<!--		Deal Name-->
<!--		<input size="md" (keyup)="onKeyUpDealName($event)" cdsText type="text" class="input-field" placeholder="New Deal">-->
<!--	</cds-text-label>-->

<!--	<cds-text-label size="md" style="margin: 8px 0" [invalid]="fundNameInvalid" [invalidText]="fundNameInvalidText">-->
<!--		Fund Name-->
<!--		<input (keyup)="onKeyUpFundName($event)" cdsText type="text" class="input-field" placeholder="New Fund">-->
<!--	</cds-text-label>-->

<!--	<cds-text-label [invalid]="dealNameInvalid" [invalidText]="dealNameInvalidText">-->
<!--		Deal Name-->
<!--		<input size="md" (keyup)="onKeyUpDealName($event)" cdsText type="text" class="input-field" placeholder="New Deal">-->
<!--	</cds-text-label>-->

	<cds-text-label [disabled]="maxedOut" size="md" style="margin: 8px 0" [invalid]="dealNameInvalid" [invalidText]="dealNameInvalidText">
		Fund Name
		<input [disabled]="maxedOut" (keyup)="onKeyUpDealName($event)" cdsText type="text" class="input-field" placeholder="New Fund">
	</cds-text-label>

	<cds-select
		size="md"
		[label]="'Fund Type'"
		[(ngModel)]="fundType"
		[invalid]="fundInvalid"
		invalidText="Select a fund type."
		(change)="onSelectFundType($event)"
		[disabled]="maxedOut"
	>
		<option *ngFor="let fundType of fundTypes.slice(0, 2)" [value]="fundType">{{fundType}}</option>
		<option *ngFor="let fundType of fundTypes.slice(2)" disabled="disabled" [value]="fundType">{{fundType}}</option>
	</cds-select>

	<div style="margin: 8px 0">
		<cds-date-picker
			[disabled]="maxedOut"
			label="Received Date"
			[invalid]="receivedDateInvalid"
			invalidText="Select a received date."
			(valueChange)="onSelectReceivedDate($event)"
		></cds-date-picker>
	</div>

	<div style="margin: 8px 0">
		<cds-date-picker
			[disabled]="maxedOut"
			[label]="'Deadline Date'"
			[invalid]="deadlineDateInvalid"
			invalidText="Select a deadline date."
			(valueChange)="onSelectDeadlineDate($event)"
		></cds-date-picker>
	</div>

	<div style="margin: 8px 0">
		<cds-date-picker
			[disabled]="maxedOut"
			label="Pricing Reference Date"
			[invalid]="pricingReferenceDateInvalid"
			invalidText="Select a pricing reference date."
			(valueChange)="onSelectPricingReferenceDate($event)"
		></cds-date-picker>
	</div>

	<cds-button-set style="padding-top: 16px">
		<button [disabled]="maxedOut" size="xl" (click)="onCreateDeal($event)" cdsButton="primary">
			Create Fund
			<svg class="cds--btn__icon" cdsIcon="folder--add" size="16"></svg>
		</button>
	</cds-button-set>
</div>
